module.exports = __webpack_public_path__ + "pcau/img/foodsdis.e8af3bc9.png";